import { Link } from 'react-router-dom';
import '../styles/Page.css';

export default function Achievements() {
  return (
    <div className="page-wrapper">
      <Link to="/" className="page-back">\u2190 Back to Home</Link>
      <h1 className="page-title">🏆 Achievements</h1>
      <p className="page-subtitle">Academic honors, awards, and recognitions.</p>
      <div className="placeholder-box">
        <div className="icon">🏆</div>
        <p>Content for <strong>Achievements</strong> goes here.</p>
        <p style={{ marginTop: 8, fontSize: '0.8rem' }}>Fill this section with your own information.</p>
      </div>
    </div>
  );
}
